export const paths = {
  auth: {
    login: '/auth/login',
    register: '/auth/register',
    callback: '/auth/callback',
  },
  filings: {
    root: '/filings',
    current: '/filings/current',
    wizard: (id: number | string) => `/filings/${id}`,
    report: (id: number | string) => `/filings/${id}/report`,
    paymentSuccess: (id: number | string) => `/filings/${id}/payment/success`,
    paymentCancel: (id: number | string) => `/filings/${id}/payment/cancel`,
  },
};
